/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon24Regular = forwardRef('NatureFxLightningAIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.651 3.236A1.5 1.5 0 0 1 8.128 2h6.253a1.5 1.5 0 0 1 1.442 1.912L14.369 9h3.189c1.26 0 1.959 1.46 1.168 2.441L9.731 22.607c-.726.901-2.176.25-1.986-.89L9.031 14h-2.51a1.5 1.5 0 0 1-1.477-1.764l1.607-9Zm7.73.264H8.128l-1.607 9h2.953c.695 0 1.224.624 1.11 1.31L9.46 20.552 17.558 10.5h-3.686a1.125 1.125 0 0 1-1.082-1.434L14.38 3.5Z" })));
});
